import PropTypes from 'prop-types'
import React from 'react'
import styles from './_svg.css'
import classnames from 'classnames'

export default function Svg ({ height, width, name, style, fill, stroke, ...props }) {

  const containerStyle = {
    height: height ? `${height}px` : null,
    width: width ? `${width}px` : null,
  }

  const svgStyle = {
    fill,
    stroke,
    ...style,
  }

  return (
    <span
      {...props}
      style={containerStyle}
      className={classnames(styles.container, props.className)}>
      <span className={styles.hitTarget} />
      <svg className={styles.svg} style={svgStyle}>
        <use xlinkHref={`#${name}`} />
      </svg>
    </span>
  )
}

Svg.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  name: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/util/Svg.jsx